enum SearchAreaStatusEnum {
  InProgress,
  Accepted,
  Declined
}

export default SearchAreaStatusEnum
